import { useTranslation } from "react-i18next"
import { Ref } from "react"
import { Search, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

export default function SearchPopoverBar({
  onSearch,
  searchQuery,
  setSearchQuery,
  inputRef,
}: {
  onSearch: () => void
  searchQuery: string
  setSearchQuery: (query: string) => void
  inputRef?: Ref<HTMLInputElement>
}) {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onSearch()
      }}
      className="flex w-full items-center gap-2"
    >
      <div className="relative min-w-0 flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          ref={inputRef}
          type="search"
          name="query"
          aria-label={t("app.search.inputLabel")}
          placeholder={t("app.search.inputPlaceholder")}
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          className="h-10 bg-background pl-9 pr-9 [&::-webkit-search-cancel-button]:hidden"
        />
        {searchQuery && (
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            aria-label={t("app.search.clear")}
            onClick={() => setSearchQuery("")}
            className="absolute right-1 top-1/2 -translate-y-1/2 text-muted-foreground"
          >
            <X className="size-4" />
          </Button>
        )}
      </div>
      <Button
        type="submit"
        className="h-10 bg-blue-600 text-white hover:bg-blue-700"
      >
        {t("common.search")}
      </Button>
    </form>
  )
}
